import { useQuery } from '@tanstack/react-query';

import { masterProfileKey } from '@/features/settings/hooks/useMasterAvatar';
import { api } from '@/shared/api';
import { env } from '@/shared/config/env';
import { ROUTES } from '@/shared/config/routes';

/**
 * The master's own public address, from the real slug. Same query key as the
 * avatar hook: one request for `/master/profile`, whichever mounts first.
 */
export const useShowcaseLink = (enabled = true) => {
  const profile = useQuery({
    queryKey: masterProfileKey,
    queryFn: () => api.get<{ slug: string }>('/master/profile'),
    enabled,
  });
  const slug = profile.data?.slug ?? null;
  const url = slug === null ? null : `${env.appUrl.replace(/\/$/, '')}${ROUTES.master(slug)}`;

  return { slug, url, display: url?.replace(/^https?:\/\//, '') ?? null };
};
